// 转弯模式
export default {
    fixedPoint: 'Stop&Turn',
    coordinate: 'Adaptive Turn'
}